module.exports = __webpack_public_path__ + "static/media/logo.483e8e13.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 606
// module chunks = 0